import handoutFilter from './src'
handoutFilter.install = Vue => {
    Vue.component(handoutFilter.name, handoutFilter)
}
export default handoutFilter



// WEBPACK FOOTER //
// ./packages/handout-filter/index.js